(function () {
  'use strict';

  if (window.__mpcMiniStackController) {
    window.__mpcMiniStackController.initAll(document);
    return;
  }

  var instances = new WeakMap();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var globalController = new AbortController();
  var globalSignal = globalController.signal;

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function canAddVariant(variant) {
    return Boolean(variant && variant.available && !variant.quantityRuleSoldout);
  }

  function positiveRule(value) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 1 ? number : 1;
  }

  function syncStickyVariant(variant, canAdd) {
    if (!document.querySelector) return;
    var stickyForm = document.querySelector('.ms-sticky-atc__form');
    if (!stickyForm) return;
    var stickyId = stickyForm.querySelector('[data-ms-sticky-variant-id]');
    var stickyQuantity = stickyForm.querySelector('[data-ms-sticky-quantity]');
    if (!stickyQuantity && document.createElement) {
      stickyQuantity = document.createElement('input');
      stickyQuantity.type = 'hidden';
      stickyQuantity.name = 'quantity';
      stickyQuantity.setAttribute('data-ms-sticky-quantity', '');
      stickyForm.appendChild(stickyQuantity);
    }
    if (stickyId) {
      stickyId.value = canAdd ? String(variant.id) : '';
      stickyId.disabled = !canAdd;
    }
    if (stickyQuantity) {
      stickyQuantity.value = String(canAdd ? positiveRule(variant.quantityMin) : 1);
      stickyQuantity.min = stickyQuantity.value;
      stickyQuantity.step = String(canAdd ? positiveRule(variant.quantityIncrement) : 1);
      stickyQuantity.disabled = !canAdd;
    }
    var stickyButton = stickyForm.querySelector('.ms-sticky-atc__btn');
    if (stickyButton) stickyButton.disabled = !canAdd;
  }

  function initStorySlider(section, signal) {
    var slider = section.querySelector('[data-mini-story-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-mini-slider-track]');
    var slides = Array.from(slider.querySelectorAll('[data-mini-slide]'));
    var dots = Array.from(slider.querySelectorAll('[data-mini-slider-dot]'));
    var previous = slider.querySelector('[data-mini-slider-prev]');
    var next = slider.querySelector('[data-mini-slider-next]');
    var currentNode = slider.querySelector('[data-mini-slider-current]');
    if (!track || !slides.length) return;

    var currentIndex = 0;

    function showSlide(index) {
      var boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({
        left: slides[boundedIndex].offsetLeft - slides[0].offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      update(boundedIndex);
    }

    function update(index) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      if (currentNode) currentNode.textContent = String(currentIndex + 1);
      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === currentIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = currentIndex === 0;
      if (next) next.disabled = currentIndex === slides.length - 1;
    }

    if (previous) previous.addEventListener('click', function () { showSlide(currentIndex - 1); }, { signal: signal });
    if (next) next.addEventListener('click', function () { showSlide(currentIndex + 1); }, { signal: signal });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { showSlide(index); }, { signal: signal });
    });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(currentIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(currentIndex + 1);
      }
    }, { signal: signal });
    track.addEventListener('scroll', function () {
      var slideWidth = track.clientWidth || 1;
      update(Math.round(track.scrollLeft / slideWidth));
    }, { passive: true, signal: signal });

    slider.classList.add('mini-slider-ready');
    update(0);
  }

  function init(section) {
    if (!section || instances.has(section)) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var variantsNode = section.querySelector('[data-mini-variants]');
    var optionSelects = Array.from(section.querySelectorAll('[data-mini-variant-select]'));
    var variantInput = section.querySelector('[data-mini-variant-id]');
    var quantityInput = section.querySelector('[data-mini-quantity]');
    var productForm = section.querySelector('form');
    var priceNode = section.querySelector('[data-mini-price]');
    var availabilityNode = section.querySelector('[data-mini-availability]');
    var button = section.querySelector('[data-mini-primary-cta]');
    var variants = [];
    var observer = null;

    initStorySlider(section, signal);
    instances.set(section, {
      destroy: function () {
        controller.abort();
        if (observer) observer.disconnect();
        section.classList.remove('mini-motion-ready');
        section.classList.remove('mini-variant-enhanced');
        var slider = section.querySelector('[data-mini-story-slider]');
        if (slider) slider.classList.remove('mini-slider-ready');
        instances.delete(section);
      }
    });

    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    function selectedVariant() {
      if (!optionSelects.length) {
        return variants.find(function (variant) { return String(variant.id) === variantInput.value; });
      }
      var options = optionSelects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return options.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    function updateVariant() {
      var variant = selectedVariant();
      if (!variant) {
        if (variantInput) {
          variantInput.value = '';
          variantInput.disabled = true;
        }
        if (quantityInput) {
          quantityInput.value = '';
          quantityInput.disabled = true;
        }
        if (button) {
          button.disabled = true;
          button.textContent = 'Sold out';
        }
        if (availabilityNode) availabilityNode.textContent = 'Sold out';
        var invalidVariant = { id: null, available: false, quantityMin: 1, quantityIncrement: 1 };
        syncStickyVariant(invalidVariant, false);
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: invalidVariant } }));
        return false;
      }

      var canAdd = canAddVariant(variant);
      var quantityMin = positiveRule(variant.quantityMin);
      var quantityIncrement = positiveRule(variant.quantityIncrement);
      if (variantInput) {
        variantInput.disabled = !canAdd;
        variantInput.value = String(variant.id);
      }
      if (quantityInput) {
        quantityInput.disabled = !canAdd;
        quantityInput.min = String(quantityMin);
        quantityInput.step = String(quantityIncrement);
        quantityInput.value = String(quantityMin);
      }
      if (priceNode) priceNode.textContent = money(variant.price);
      if (availabilityNode) availabilityNode.textContent = canAdd ? 'In stock' : 'Sold out';
      if (button) {
        button.disabled = !canAdd;
        button.textContent = canAdd ? 'Add to cart' : 'Sold out';
      }

      var eventVariant = Object.assign({}, variant, { available: canAdd });
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: eventVariant } }));
      syncStickyVariant(eventVariant, canAdd);
      return true;
    }

    if (!variants.length || !variantInput || !productForm || !selectedVariant()) return;

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateVariant, { signal: signal });
    });
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        var quantity = quantityInput ? Number(quantityInput.value) : 1;
        var minimum = quantityInput ? positiveRule(quantityInput.min) : 1;
        var increment = quantityInput ? positiveRule(quantityInput.step) : 1;
        var invalidQuantity = !Number.isFinite(quantity) || quantity < minimum || (quantity - minimum) % increment !== 0;
        if (!variantInput || variantInput.disabled || !variantInput.value || !quantityInput || quantityInput.disabled || invalidQuantity) event.preventDefault();
      }, { signal: signal });
    }
    if (!updateVariant()) return;
    section.classList.add('mini-variant-enhanced');

    var revealNodes = Array.from(section.querySelectorAll('[data-mini-reveal]'));
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealNodes.forEach(function (node) { node.classList.add('is-visible'); });
    } else {
      section.classList.add('mini-motion-ready');
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      revealNodes.forEach(function (node) { observer.observe(node); });
    }

  }

  function destroy(section) {
    var instance = section && instances.get(section);
    if (instance) instance.destroy();
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('[data-mini-section]')) init(scope);
    scope.querySelectorAll('[data-mini-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true, signal: globalSignal });
  } else {
    initAll(document);
  }

  window.__mpcMiniStackController = {
    globalController: globalController,
    initAll: initAll,
    teardown: function () {
      globalController.abort();
      window.__mpcMiniStackController = null;
    }
  };

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); }, { signal: globalSignal });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches('[data-mini-section]') ? event.target : event.target.querySelector('[data-mini-section]');
    destroy(section);
  }, { signal: globalSignal });
})();
